<template>
  <RevButton v-if="!error" :to="url" variant="primary">
    <slot></slot>
  </RevButton>
</template>

<script setup lang="ts">
import { RevButton } from '@ds/components/Button'

import { useMilitaryDiscountUrl } from './useMilitaryDiscountUrl'

const { url, error } = useMilitaryDiscountUrl()
</script>
